import * as adminAuthApi from './api/endpoints/auth';
import type { AdminLoginResponse } from './api/schemas';
import { setAdminSession, type StoredAdminSession } from './session-store';

/** The session the HQ keeps for one login answer; a new object, the answer untouched. */
export function storedAdminSessionFrom(result: AdminLoginResponse): StoredAdminSession {
  return {
    transport: result.sessionTransport,
    adminId: result.adminId,
    username: result.username,
    expiresAt: result.expiresAt,
    mustChangePassword: result.mustChangePassword,
    ...(result.sessionTransport === 'bearer' && result.sessionToken ? { token: result.sessionToken } : {}),
  };
}

/**
 * Signs in to the HQ and keeps the session where the HQ restores it from, so
 * a login that starts outside the HQ (the business login, where Martín types
 * out of habit, 2026-11-02) lands on `/admin` already signed in.
 */
export async function signInAsAdmin(username: string, password: string): Promise<AdminLoginResponse> {
  const result = await adminAuthApi.login(username, password);
  setAdminSession(storedAdminSessionFrom(result));
  return result;
}
